import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { isPlatform } from "@ionic/react";
import { useLocation } from "react-router";

import ContactsApi from "../api/contacts";
import useCountersStore from "../store/counts";

const mobile = isPlatform("android") || isPlatform("ios");

export default function CountsStateSynchronizer() {
  const { setLoading, setCounters } = useCountersStore((state) => ({
    setLoading: state.setLoading,
    setCounters: state.setCounters,
  }));
  const stateData = useCountersStore((state) => ({
    escalated: state.escalated,
    manualUnread: state.manualUnread,
    archived: state.archived,
  }));

  const location = useLocation();
  const path = location.pathname;
  const enableRefetchInterval = !path.includes("/chat");

  const countsQuery = useQuery({
    queryFn: () => ContactsApi.getCounts(),
    queryKey: ["getCounts"],
    refetchOnWindowFocus: mobile,
    refetchOnReconnect: true,
    refetchInterval: enableRefetchInterval ? 200000 : false,
    refetchIntervalInBackground: enableRefetchInterval,
  });

  useEffect(() => {
    setLoading(countsQuery.status === "loading");
  }, [countsQuery.status]);

  useEffect(() => {
    if (
      countsQuery.data &&
      (countsQuery.data.escalated !== stateData.escalated ||
        countsQuery.data.manualUnread !== stateData.manualUnread ||
        countsQuery.data.archived !== stateData.archived)
    ) {
      setCounters(countsQuery.data);
    }
  }, [countsQuery.data]);

  return null;
}
